<!-- 报警触发----设备触发器 -->
<template>
    <div class="main">
        <!-- 表格 -->
        <div class="head">
            <!-- 搜索区域 -->
            <div class="searchArea">
                <div class="title">查询数据</div>
                <div class="content">
                    <el-form style="width: 90%"  label-width="90px">
                        <el-row :gutter="24">
                        <el-col :span="12">
                            <el-form-item label="选择设备：">
                            <el-select v-model="searchParams.deviceCodes" placeholder="请选择设备" size="small" clearable multiple filterable>
                                <el-option
                                    v-for="(item,index) in deviceList"
                                    :key="index"
                                    :label="item.name" :value="item.code"></el-option>
                            </el-select>
                            </el-form-item>
                        </el-col>
                        <el-col :span="12">
                           <el-form-item label="选择变量：">
                                <el-select v-model="searchParams.params" placeholder="请选择" size="small" clearable filterable>
                                    <el-option
                                    v-for="(item,index) in paramsList"
                                    :key="index"
                                    :label="item.name" :value="item.name"></el-option>
                                </el-select>
                            </el-form-item>
                        </el-col>
                        </el-row>
                        <el-row :gutter="24">
                        <el-col :span="12">
                            <el-form-item label="状态开关：">
                            <el-select v-model="searchParams.status" placeholder="请选择" size="small" clearable>
                                    <el-option
                                    v-for="(item,index) in statusList"
                                    :key="index"
                                    :label="item.label" :value="item.id"></el-option>
                                </el-select>
                            </el-form-item>
                        </el-col>
                        <el-col :span="12">
                            <el-form-item label="触发条件：">
                            <el-select v-model="searchParams.condition" placeholder="请选择" size="small" clearable>
                                    <el-option
                                    v-for="(item,index) in triggerConditionList"
                                    :key="index"
                                    :label="item.value" :value="item.id"></el-option>
                                </el-select>
                            </el-form-item>
                        </el-col>
                        </el-row>
                    </el-form>
                    <div class="block"></div>
                    <div class="rightBtn">
                        <el-button type="primary" icon="el-icon-search" size="small" class="btnStyle" style="margin-bottom:0.1rem" @click="onSearch">查询</el-button>
                        <el-button icon="el-icon-refresh-left" size="small" style="margin-left: 0;">重置</el-button>
                    </div>
                </div>
            </div>
        </div>
        <!-- 表格区域 -->
        <div class="tableArea">
            <!-- 操作区域 -->
            <div class="option">
                <div>
                    <el-input placeholder="请输入触发器名称" style="width: 5rem;" size="small" v-model="searchParams.title" >
                        <i slot="prefix" class="el-input__icon el-icon-search"></i>
                        <el-button type="primary" slot="append" @click="onSearch">搜索</el-button>
                    </el-input>
                </div>
                <div>
                    <el-button type="primary" size="small" icon="el-icon-plus" class="btnStyle" @click="operation('add')">设备触发</el-button>
                    <el-button icon="el-icon-delete" size="small" @click="deletionByQuery()">删除</el-button>
                </div>
            </div>
            <div class="table">
                <el-table :data="tableData" style="width: 100%" row-key="id" :header-cell-style="{background:'#FAFAFA',color:'#405891'}" @selection-change="handleSelectionChange">
                    <el-table-column type="selection" width="55"  reserve-selection></el-table-column>
                    <el-table-column label="序号" width="80">
                    <template slot-scope="scope">
                        {{scope.$index+1}}
                    </template>
                    </el-table-column>
                    <el-table-column type="expand">
                    <template slot-scope="scope">
                        <div v-for="(item,index) in (JSON.parse(scope.row.codes))" :key="index" style="line-height:0.8rem;border-bottom:1px solid #e9e9eb;color:#405891">
                            <span style="margin-left:2.8rem">{{getName(item).name}}</span>
                            <span style="margin-left:0.8rem">{{getName(item).dname}}</span>
                            <i v-if="getName(item).dname" class="el-icon-document-copy" style="cursor:pointer;margin-left:0.8rem" @click="copyBtn(getName(item).dname)"></i>
                        </div>
                    </template>
                    </el-table-column>
                    <el-table-column prop="codes" label="设备名称" width="200">
                        <template slot-scope="scope">
                           <span>{{getDeviceName(scope.row.codes)}}</span>
                        </template>
                    </el-table-column>
                    <el-table-column>
                        <template slot-scope="scope">
                           <span>{{(JSON.parse(scope.row.codes)).length + '台'}}</span>
                        </template>
                    </el-table-column>
                    <el-table-column prop="title" label="触发器名称" width="150">
                    </el-table-column>
                    <el-table-column prop="params" label="变量">
                    </el-table-column>
                    <el-table-column prop="condition" label="触发条件">
                        <template slot-scope="scope">
                           <span>{{getCondition(scope.row.condition)}}</span>
                        </template>
                    </el-table-column>
                    <el-table-column prop="params" label="设定值">
                    </el-table-column>
                     <el-table-column prop="mechanism" label="推送机制" width="200">
                        <template slot-scope="scope">
                          <span>{{scope.row.mechanism == 1?'仅发一次':'间隔一定时间发送'}}</span>
                        </template>
                    </el-table-column>
                    <el-table-column prop="push" label="推送方式">
                        <template slot-scope="scope">
                          <span>{{scope.row.push == 1?'短信':(scope.row.push ==2?'邮件':'短信 ，邮件')}}</span>
                        </template>
                    </el-table-column>
                    <el-table-column prop="is_use" label="状态" >
                    <template slot-scope="scope" >
                        <el-switch active-value="1"  inactive-value="2" v-model="scope.row.is_use" active-color="#35C75C" inactive-color="#E9E9EB" @change="changeStatus($event,scope.row)">
                        </el-switch>
                    </template>
                    </el-table-column>
                    <el-table-column label="操作" width="150" fixed="right">
                    <template slot-scope="scope">
                        <el-button style="color:#437EDE" type="text" @click="operation('edit',scope.row)">编辑</el-button>
                        <el-button type="text"  @click="handleTop(scope.row,scope.$index)" :disabled="scope.$index ==0" >置顶</el-button>
                        <el-button style="color:#437EDE" type="text" @click="handleDelete(scope.row)">删除</el-button>
                    </template>
                    </el-table-column>
                </el-table>
                <div style="margin-top:0.2rem;text-align:right;">
                    <a-pagination v-model="current" show-quick-jumper show-size-changer :page-size-options="pageSizeOptions" :total="totalCount" @change="onChange" @showSizeChange="pageSizeChange" />
                </div>
            </div>
        </div>
        <!-- 新增设备触发弹框 -->
        <el-dialog :title="dialogTitle+'新增设备触发'" :visible.sync="dialogVisible" width="50%" @close="onCancle">
            <el-form  label-width="120px" :model="addFormValue" :rules="rules" ref="addFormValue">
                <el-form-item label="触发器名称：" prop="title">
                    <el-input placeholder="请输入名称" size="small" v-model="addFormValue.title"></el-input>
                </el-form-item>
                <el-form-item label="选择设备：" prop="codes">
                    <el-select v-model="deviceCodes" placeholder="请选择设备" size="small" multiple filterable>
                        <el-option
                            v-for="(item,index) in deviceList.slice(1)"
                            :key="index"
                            :label="item.name" :value="item.code"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="选择变量：" prop="params">
                    <el-select v-model="addFormValue.params" placeholder="请选择变量" size="small" filterable>
                    <el-option
                        v-for="(item,index) in paramsList.slice(1)"
                        :key="index"
                        :label="item.name" :value="item.name"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="触发条件：" prop="condition">
                    <div style="display:flex">
                        <el-select v-model="addFormValue.condition" placeholder="请选择触发条件" size="small">
                            <el-option  v-for="(item,index) in triggerConditionList.slice(1)" :key="index"  :label="item.value" :value="item.id"></el-option>
                        </el-select>
                        <div style="margin-left:10px">
                            <el-input v-if="addFormValue.condition==1 ||addFormValue.condition==2||addFormValue.condition==3||addFormValue.condition==4"
                            placeholder="A=" size="small" v-model="addFormValue.A"></el-input>
                            <el-input v-if="addFormValue.condition==3 ||addFormValue.condition==4" placeholder="B=" size="small" v-model="addFormValue.B"></el-input>
                        </div>
                    </div>
                </el-form-item>
                <el-form-item label="推送机制：" prop="mechanism">
                    <div>变量值达到巅峰时</div>
                    <el-radio-group v-model="addFormValue.mechanism" type="vertical">
                        <el-radio :label="1">仅一次推送</el-radio>
                        <div style="display:flex;aligin-items:center">
                            <el-radio :label="2">报警沉默时间</el-radio>
                            <el-input v-if="addFormValue.mechanism ==2" v-model="addFormValue.interval" placeholder="请输入" size="small" style="width:1.5rem"></el-input>
                            <div style="margin-left:0.1rem" v-if="addFormValue.mechanism ==2"><el-popover
                            ref="popover"
                            popper-class="popperStyle"
                            placement="right"
                            title="报警沉默时间:"
                            width="300"
                            trigger="hover"
                            content="假设设备的采集更新频率为1小时，报警沉默时间设置的1分钟。第一次报警（8:00）触发，立即推送，第二次报警需要下一次轮询并且设备还是处于报警状态（9:01）。">
                            <el-button slot="reference" size="small" type="text" style="color:#93A6D2;font-size:0.14rem">分钟<i class="el-icon-question"></i></el-button>
                            </el-popover>
                            </div>
                        </div>
                    </el-radio-group>
                </el-form-item>
                 <el-form-item label="选择联系人：" prop="contact_ids">
                        <el-select v-model="contactIds" placeholder="请选择联系人" size="small" multiple>
                        <el-option  v-for="(item,index) in contactList" :key="index"  :label="item.username" :value="item.id"></el-option>
                        </el-select>
                </el-form-item>
                <el-form-item label="推送方式：" prop="push">
                    <div style="display:flex">
                        <el-checkbox-group v-model="pushList">
                            <el-checkbox :label="1">短信</el-checkbox>
                            <el-checkbox :label="2">邮件</el-checkbox>
                        </el-checkbox-group>
                        <div style="margin-left:40px;color:#93A6D2"><i class="el-icon-info"></i>最少选择一种联系方式</div>
                    </div>
                </el-form-item>
                <el-form-item label="推送内容：">
                    <el-input v-model="addFormValue.push_info" type="textarea" placeholder="请输入内容"></el-input>
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
            <el-button @click="onCancle" size="small">取 消</el-button>
            <el-button type="primary" size="small" class="btnStyle" @click="addDeviceTrigger">保 存</el-button>
            </div>
        </el-dialog>
    </div>
</template>
<script>
import { getTriggerList, addTrigger, getDeviceParams, editTrigger, delTrigger } from '@/api/page/alarmTrigger.js'
import { getAreaList } from '@/api/page/deviceList.js'
import { getContactList } from '@/api/page/contactList.js';
export default {
    data() {
        return {
            dialogTitle: "新增",
            // 搜索
            searchParams:{
               deviceCodes:[],
               codes:"",
               params:'全部',
               condition: 0,
               status: 0,
               title:"",
            },
            tableData:[],// 表格数据
            page: 1,
            limit: 10,
            totalCount: null,
            current:1,
            selectedRows:[],
            dialogVisible:false, //控制弹框显隐
            deviceList:[],
            paramsList:[],
            contactIds:[],
            deviceCodes:[],
            contactList:[],
            pushList:[],
            //新增综合触发弹框数据
            addFormValue:{
               type: 2,
               is_use: 2,
               title:"",
               codes:"",
               params:"",
               condition:"",
               A:"",
               B:"",
               mechanism:"",
               interval: "",
               contact_ids: "",
               push: "",
               push_info:""
            },
            rules: {
                title: [
                    { required: true, message: '请输入名称', trigger: 'blur' },
                ],
                codes: [
                    { required: true, message: '请选择设备', trigger: 'change' },
                ],
                params: [
                    { required: true, message: '请选择变量', trigger: 'change' },
                ],
                condition: [
                    { required: true, message: '请选择触发条件', trigger: 'change' },
                ],
                mechanism:[
                    { required: true, message: '请选择推送机制', trigger: 'change' },
                ],
                contact_ids:[
                    { required: true, message: '请选择联系人', trigger: 'change' },
                ],
                push:[
                    { required: true, message: '请选择推送方式', trigger: 'change' },
                ]
            },
            pageSizeOptions: ['10','20','30','40','50'],
        }
    },
    mounted() {
       this.getDeviceList()
       this.getDeviceParams()
       this.getTriggerList()
       this.getContactList()
    },
    methods: {
        // 获取设备列表
        getDeviceList() {
          let self = this;
          let data = {
            account: window.localStorage.getItem('account'),
            is_all: 1,
            is_gkz: 2,
            token: window.localStorage.getItem('token'),
            ts:this.stringTime(new Date())
          };
          getAreaList(data).then(res=> {
            self.deviceList = res.data
            self.deviceList.unshift({
                name: '全部',
            })
          })
        },
        // 获取变量
        getDeviceParams() {
        let self = this;
        let data = {
            account: window.localStorage.getItem('account'),
            token: window.localStorage.getItem('token'),
            ts:this.stringTime(new Date())
        }
        getDeviceParams(data).then(res=> {
            self.paramsList = res.data
            self.paramsList.unshift({
                name: '全部',
            })
        })

        },
        // 获取触发器列表
        getTriggerList() {
            let self = this;
            let data = {
                account: window.localStorage.getItem('account'),
                type: 2,
                page: self.page,
                limit: self.limit,
                title: self.searchParams.title,
                condition: self.searchParams.condition,
                is_use: self.searchParams.status,
                params: self.searchParams.params== "全部"? "": self.searchParams.params,
                codes: self.searchParams.codes,
                token: window.localStorage.getItem('token'),
                ts:this.stringTime(new Date())
            }
            getTriggerList(data).then(res=> {
                self.tableData = res.data
                self.totalCount = res.meta.total_count
            })
        },
        // 获取联系人列表
        getContactList() {
        let data = {
            account: window.localStorage.getItem('account'),
            token: window.localStorage.getItem('token'),
            ts: this.stringTime(new Date())
        };
        getContactList(data).then(res=> {
            this.contactList = res.data
        })
        .catch((err)=> {
            console.log('error',err)
        })
        },
        getCondition(val) {
            let self = this;
            let condition = "";
            self.triggerConditionList.forEach(item=> {
                if(item.id == val) {
                    condition = item.value
                }
            })
            return condition
       },
       getDeviceName(val) {
         let self = this;
         let deviceName = [];
         let codes = JSON.parse(val)
         self.deviceList.forEach(item=> {
            codes.forEach(v=> {
                if(item.code == v) {
                    deviceName.push(item.name)
                }
            })
         })
         let arr = deviceName.join(',')
         return arr
       },
       getName(val) {
          let  self = this;
          let  deviceName = {};
          self.deviceList.forEach(item=> {
            if(val == item.code) {
               deviceName = item
            }
          })
          return deviceName
       },
        // 触发器搜索
        onSearch() {
         this.page = 1
         this.limit = 10
         this.getTriggerList()
        },
        // 触发编辑or添加按钮
        operation(type,val) {
            this.dialogVisible = true;
            this.dialogTitle = (type== 'add'? '新增':'编辑')
            if(type=='edit'&&val) {
                this.$nextTick(()=> {
                    this.addFormValue = Object.assign({},val)
                    this.addFormValue.condition = Number(val.condition)
                    this.deviceCodes = JSON.parse(val.codes)
                    let arr = JSON.parse(val.contact_ids)
                    arr.forEach(i=> {
                       this.contactIds.push(i.toString())
                    })
                    this.addFormValue.mechanism = Number(val.mechanism)
                    if(val.push == '3') {
                      this.pushList = [1,2]
                    } else {
                      this.pushList.push(Number(val.push))
                    }
                })
            }
       },
        // 新增设备触发
        addDeviceTrigger() {
            this.dialogVisible = true
            let data = {
                type:2,
                is_use: 2,
                account: window.localStorage.getItem('account'),
                token: window.localStorage.getItem('token'),
                ts:this.stringTime(new Date())
            }
            let obj = Object.assign(data,this.addFormValue)
            this.$refs.addFormValue.validate((valid)=> {
                if(valid) {
                    if(!this.addFormValue.A) {
                        this.$message.warning('请输入A值')
                        return
                    }
                    if(this.addFormValue.condition == 3 || this.addFormValue.condition == 4) {
                        if(!this.addFormValue.B) {
                            this.$message.warning('请输入B值')
                            return
                        }
                    }
                    if(this.addFormValue.mechanism ==2) {
                        if(!this.addFormValue.interval) {
                            this.$message.warning('请输入报警沉默时间')
                            return
                        }
                    }
                    if(this.dialogTitle== '新增') {
                        addTrigger(obj).then(res=> {
                            if(res.data == 'success') {
                                this.$message.success('添加成功')
                                this.dialogVisible = false;
                                this.getTriggerList()
                            }
                        })
                    } else {
                        editTrigger(obj).then(res=> {
                            if(res.data == 'success') {
                                this.$message.success('编辑成功')
                                this.dialogVisible = false;
                                this.getTriggerList()
                            }
                        })
                    }
                } else {
                    return false
                }
            })
        },
        onCancle() {
            this.dialogVisible = false
            this.contactIds = []
            this.pushList = []
            this.$refs['addFormValue'].resetFields();
        },
        // 置顶
        handleTop(row,index) {
          this.tableData.splice(index,1)
          this.tableData.unshift(row)
        },
        // 删除
        handleDelete(item) {
            let self = this;
            this.$confirm(`确定要删除${item.title}触发器吗？`,'提示',{
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(()=> {
                this.onDelete(item.id)
            }).catch(()=> {

            })
        },
        onDelete(id) {
            let data = {
                account: window.localStorage.getItem('account'),
                token: window.localStorage.getItem('token'),
                tid: id,
                ts: this.stringTime(new Date())
            }
            delTrigger(data).then(res=> {
                if(res.data == 'success') {
                this.$message({
                    message:'删除成功',
                    type: 'success'
                })
                this.getTriggerList()
                } else {
                this.$message({
                    message:'删除失败，请重试',
                    type: 'warning'
                })
                }
            })
        },
        // 选中的列表
        handleSelectionChange(val) {
            this.selectedRows = [];
            this.selectedRows = val;
        },
        // 批量删除
        deletionByQuery() {
            if(this.isNull(this.selectedRows)) {
                this.$message.warning('请选择需要删除的触发器')
                return
            }
            let arr = [];
            let ids = [];
            this.selectedRows.forEach(item=> {
                arr.push(item.title)
                ids.push(item.id)
            })
            this.$confirm(`确定要删除${arr.join(',')}吗？`,'提示',{
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(()=> {
                ids.forEach(j=> {
                this.onDelete(j)
                })
            }).catch(()=> {

            })
        },
        // 分页跳转
        onChange(val) {
            this.page = val
            this.getTriggerList()
        },
        pageSizeChange(page,pageSize) {
            this.limit = pageSize
            this.getTriggerList()
        },
        changeStatus(status,val) {
            let arr = JSON.parse(val.contact_ids)
            let contacts = []
            let codeList = JSON.parse(val.codes)
            arr.forEach(i=> {
              contacts.push(i.toString())
            })
            val.contact_ids = contacts.join(',')
            val.codes = codeList.join(',')
            let data = {
            type:2,
            account: window.localStorage.getItem('account'),
            token: window.localStorage.getItem('token'),
            ts: this.stringTime(new Date())
            }
            let obj = Object.assign(data,val)
            editTrigger(obj).then(res=> {
                if(res.data == 'success') {
                this.$message.success('修改成功')
                this.getTriggerList()
            }
            })
        }
  },
   watch:{
    pushList(val) {
      if(val.length ==1) {
        this.addFormValue.push = val[0]
      } else if (val.length ==2) {
        this.addFormValue.push = 3
      }
    },
    contactIds(val) {
       let arr = val.join(',')
       this.addFormValue.contact_ids = arr
    },
    deviceCodes(val) {
        let arr = val.join(',')
        this.addFormValue.codes = arr
    },
    "searchParams.deviceCodes":{
        handler(val) {
        let arr = val.join(',')
        this.searchParams.codes = arr
        }
    }
  },
  computed: {
    triggerConditionList(){
        return this.$store.state.triggerConditionList
    },
    statusList() {
        return this.$store.state.statusList
    },
  }
}
</script>
<style scoped lang="less">
    // 搜索框
    .content::v-deep .el-form-item {
        margin-bottom: 0.1rem;
        .el-form-item__label {
            color: #405891;
        }
    }
    ::v-deep .el-input-group__append, .el-input-group__prependtyle {
        background: #437ede;
        border-color: #437ede;
        color: #fff;
    }
    ::v-deep .el-radio {
        display:inline-block;
        margin-top: 10px;
    }
</style>
